var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"国内市场布局","name":"1"}},[_c('layoutin')],1),_c('el-tab-pane',{attrs:{"label":"海外市场布局","name":"2"}},[_c('layoutout')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }